
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'transactions'
    })
  } // computed
}; // export default
